import { listOffers } from '@wix/ambassador-dealer-v1-serving-offer/http';
import { getSignedInstance } from './getSignedInstance';
const mapOfferToDealerOffer = offer => {
  let creative;
  if (offer.asset) {
    // Prefer creative if it exists
    if (offer.asset.creative !== undefined) {
      creative = offer.asset.creative;
    } else if ('payloadJson' in offer.asset && offer.asset.payloadJson !== undefined) {
      // Handle payloadJson - can be a string or already parsed object
      const payloadJson = offer.asset.payloadJson;
      if (typeof payloadJson === 'string') {
        try {
          creative = JSON.parse(payloadJson);
        } catch {
          creative = undefined;
        }
      } else {
        creative = payloadJson;
      }
    }
  }
  return {
    offerGuid: offer.offerGuid,
    realEstateId: offer.realEstateId,
    offerName: offer.offerName,
    asset: offer.asset ? {
      creative,
      dynamicParams: offer.asset.dynamicParams
    } : undefined,
    campaignId: offer.campaignId,
    startDate: offer.startDate,
    endDate: offer.endDate
  };
};
export const listOffersHttpQueryFn = async _ref => {
  var _response$data;
  let {
    httpClient,
    request
  } = _ref;
  const {
    placementId,
    siteId,
    customParams,
    limit,
    siteAuthorizationType
  } = request;
  let signedInstance;
  if (siteId && siteAuthorizationType === 'authorized') {
    try {
      signedInstance = await getSignedInstance(httpClient, siteId);
    } catch {
      // Failed to get signed instance, continue without it
    }
  } else {
    return [];
  }
  const dealerRequest = listOffers({
    realEstateId: placementId,
    extensions: siteId ? {
      siteId
    } : undefined,
    customParams,
    limit
  });
  const response = await httpClient.request(dealerRequest, signedInstance ? {
    signedInstance
  } : undefined);
  const offers = ((_response$data = response.data) == null ? void 0 : _response$data.offers) ?? [];
  return offers.map(mapOfferToDealerOffer);
};
//# sourceMappingURL=listOffersHttp.query.js.map